import { api } from "@/lib/api";
import type { AdminDto, PageResponse } from "@/types/api";

export interface AdminListParams {
    page?: number;
    size?: number;
    sort?: string;
}

export interface CreateAdminRequest {
    email: string;
    password: string;
}

export interface UpdateAdminRequest {
    email?: string;
    password?: string;
}

export async function listAdminsPaged(params: AdminListParams = {}): Promise<PageResponse<AdminDto>> {
    const q: Record<string, string | number> = {};
    if (params.page != null) q.page = params.page;
    if (params.size != null) q.size = params.size;
    if (params.sort) q.sort = params.sort;
    const { data } = await api.get<PageResponse<AdminDto>>("/admin/admins", { params: q });
    return data;
}

export async function listAdmins(): Promise<AdminDto[]> {
    const data = await listAdminsPaged({ size: 1000 });
    return data.content;
}

export async function createAdmin(request: CreateAdminRequest): Promise<AdminDto> {
    const { data } = await api.post<AdminDto>("/admin/admins", request);
    return data;
}

export async function updateAdmin(id: number, request: UpdateAdminRequest): Promise<AdminDto> {
    const { data } = await api.patch<AdminDto>(`/admin/admins/${id}`, request);
    return data;
}

export async function deleteAdmin(id: number): Promise<void> {
    await api.delete(`/admin/admins/${id}`);
}

/**
 * Suspend an admin — blocks login and revokes their sessions immediately.
 * Backend refuses with 409 for self-suspend and 403 for the bootstrap admin.
 */
export async function deactivateAdmin(id: number): Promise<AdminDto> {
    const { data } = await api.post<AdminDto>(`/admin/admins/${id}/deactivate`);
    return data;
}

/** Reinstate a suspended admin — they can log in again. */
export async function activateAdmin(id: number): Promise<AdminDto> {
    const { data } = await api.post<AdminDto>(`/admin/admins/${id}/activate`);
    return data;
}
